import { useQuery } from '@tanstack/react-query';
import { toastFn } from 'src/utils/helpers';
import Configurations from '../../../settings';
import { track } from '../../../utils/telemetry';

const getCommodityCodesData = async (query: string) => {
  try {
    const response = await fetch(
      `${Configurations.COGNITIVE_SEARCH_COMMODITY_CODES_ENDPOINT}/indexes/${Configurations.COGNITIVE_SEARCH_COMMODITY_CODES_INDEX}/docs?api-version=${Configurations.COGNITIVE_SEARCH_COMMODITY_CODES_VERSION}=${encodeURIComponent(query)}&$top=100&queryType=semantic&captions=extractive&answers=extractive|count-3&semanticConfiguration=${Configurations.COGNITIVE_SEARCH_COMMODITY_CODES_SEMANTIC}`,
      {
        headers: {
          'api-key': Configurations.COGNITIVE_SEARCH_COMMODITY_CODES_API_KEY,
        },
      },
    );

    if (response.status !== 200) {
      throw new Error(response.statusText);
    }

    return await response.json();
  } catch (error) {
    toastFn('error', 'Failed to fetch commodity codes data. Please try again later.');
    track('GetCommodityCodesCognitiveSearch -- getcommoditiyCognitiveSearchData.ts -- ERROR:', {error});
    throw error;
  }
};

export const useGetCommodityCodesCognitiveSearch = (query: string,options={}) => {
  return useQuery({
    queryKey: ['-COGNITIVE SEARCH-CommodityCodes', query],
    queryFn: async () => {
      if (query === '') {
        return { data: [] };
      } else {
        const response = await getCommodityCodesData(query);


        return response;
      }
    },
    ...options,
  });
};
